module.exports = __webpack_public_path__ + "static/media/active_agent.78afd443.svg";